import gsx from 'styles'

const styles = {
  quickLinks: {
    '& .MuiGrid2-root': {
      width: { xs: '50%', sm: '150px' },
      '.Tile-root ': {
        span: {
          fontWeight: '600',
        },
      },
    },
    '& .MuiGrid2-root:last-child': {
      width: { xs: '100%', sm: '150px' },
      a: {
        width: '100%',
      },
    },
  },

  freeDeliveryText: { textAlign: { xs: 'center', md: 'left' } },

  googleReviewsContainer: {
    marginTop: 3,
    '& > .MuiGrid-container': {
      ...gsx.googleReviewsContainer,
    },
  },
}

export default styles
